const offlineMessage = {
  noInternet:
    'No internet connection detected. Pomelo will automatically try to reconnect when it detects an internet connection.',
  noAPI:
    "Something is technically wrong. We're going to fix it up and have things back to normal soon.",
}

export default offlineMessage
